const dropdownDefaultStyleProperties = {
    anchor: 'screen',
    'space-above': '0px',
    'horizontal-margin': '0px',
    align: 'start'
}

module.exports = {
    dropdownDefaultStyleProperties
}
